import { useState } from "react";
import { FiRefreshCcw, FiEdit2, FiTrash2, FiEye } from "react-icons/fi";
import { FaPlus } from "react-icons/fa";
import Table from "../../components/Table/index.jsx";
import { Link } from "react-router-dom";
import { HiOutlineUpload } from "react-icons/hi";
import { IoIosAddCircle } from "react-icons/io";

const FranchiseList = () => {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [showConfirm, setShowConfirm] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    // 🔍 Search Filters
    const [filters, setFilters] = useState({
        name: "",
        fromDate: "",
        toDate: "",
    });

    // Dummy static data (UI only)
    const dummyData = [
        {
            id: "D001",
            name: "Raj Patel",
            email: "raj@example.com",
            contact: "9876543210",
            address: "Ahmedabad, 380015",
            vehicleNumber: "GJ01AB1234",
            createdAt: "2025-09-10",
        },
        {
            id: "D002",
            name: "Amit Shah",
            email: "amit@example.com",
            contact: "9876500000",
            address: "Surat, 395006",
            vehicleNumber: "GJ05CD5678",
            createdAt: "2025-09-11",
        },
    ];

    // Simple filter logic
    const filteredData = dummyData.filter((row) => {
        return (
            (filters.name === "" ||
                row.name.toLowerCase().includes(filters.name.toLowerCase())) &&
            (filters.fromDate === "" || new Date(row.createdAt) >= new Date(filters.fromDate)) &&
            (filters.toDate === "" || new Date(row.createdAt) <= new Date(filters.toDate))
        );
    });

    // Columns for table
    const orderTableColumns = [
        {
            name: "Registered Date",
            cell: (row) => (
                <span className="text-xs text-gray-700">
                    {new Date(row?.createdAt).toLocaleDateString()}
                </span>
            ),
            width: "140px",
        },
        {
            name: "Franchise ID",
            cell: (row) => (
                <span className="text-blue-600 text-xs font-medium">{row.id}</span>
            ),
            width: "140px",
        },
        {
            name: "Name",
            cell: (row) => (
                <span className="text-xs text-gray-800 font-medium">{row.name}</span>
            ),
            width: "160px",
        },
        {
            name: "Email ID",
            cell: (row) => (
                <span className="text-blue-600 text-xs font-medium">{row.email}</span>
            ),
            width: "200px",
        },
        {
            name: "Contact No.",
            cell: (row) => (
                <span className="text-xs text-gray-700">{row.contact}</span>
            ),
            width: "140px",
        },
        {
            name: "Address",
            cell: (row) => (
                <span className="text-xs text-gray-700">{row.address}</span>
            ),
            minWidth: "160px",
        },
        {
            name: "City",
            cell: (row) => (
                <span className="text-blue-600 text-xs font-medium">{row.id}</span>
            ),
            width: "140px",
        },
        {
            name: "State",
            cell: (row) => (
                <span className="text-blue-600 text-xs font-medium">{row.id}</span>
            ),
            width: "140px",
        },
        {
            name: "pincode",
            cell: (row) => (
                <span className="text-blue-600 text-xs font-medium">{row.id}</span>
            ),
            width: "140px",
        },

        {
            name: "Action",
            cell: (row) => (
                <div className="flex items-center gap-3">
                    {/* View button/link */}
                    {/* <button
                        className="text-blue-600 hover:text-blue-800 text-xs font-medium border border-black rounded px-2 py-1"
                        onClick={() => alert(`View details of ${row.name}`)}
                    >
                        View RO Details
                    </button> */}


                    {/* View Button with Link */}
                    <Link
                        to="/franchisesinglepage" // dynamic route based on row.id
                        className="text-green-600 hover:text-green-800"
                    >
                        <FiEye />
                    </Link>

                    {/* Edit Button */}
                    {/* <Link
                        to="/franchiseaddfrom"
                        className="text-blue-600 hover:text-blue-800"
                    // onClick={() => alert(`Edit ${row.name}`)}
                    >
                        <IoIosAddCircle />
                    </Link> */}

                    {/* Delete Button */}
                    <button
                        className="text-red-600 hover:text-red-800"
                        onClick={() => {
                            setSelectedRow(row);
                            setShowConfirm(true);
                        }}
                    >
                        <FiTrash2 />
                    </button>
                </div>
            ),
            width: "250px", // increased width for 3 buttons
        }
    ];

    return (
        <>
            <div className="w-full px-4 pt-6 pb-10 border border-gray-200 md:rounded-md bg-white">
                {/* Header */}
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
                    <p className="text-lg font-semibold text-slate-800">
                        Franchise List
                    </p>


                </div>

                {/* 🔍 Filters Section */}
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
                    <input
                        type="text"
                        placeholder="Name"
                        value={filters.name}
                        onChange={(e) => setFilters({ ...filters, name: e.target.value })}
                        className="h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none"
                    />

                    <input
                        type="date"
                        value={filters.fromDate}
                        onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
                        className="h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none"
                    />
                    <input
                        type="date"
                        value={filters.toDate}
                        onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
                        className="h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none"
                    />
                </div>

                {/* Reset Button */}
                <button
                    onClick={() =>
                        setFilters({
                            name: "",
                            id: "",
                            email: "",
                            contact: "",
                            fromDate: "",
                            toDate: "",
                        })
                    }
                    className="mb-4 px-5 py-2 bg-blue-50 hover:bg-blue-100 rounded-md text-sm"
                >
                    Reset Filters
                </button>

                {/* Table */}
                <div className="text-gray-600 grid grid-cols-1">
                    <Table
                        columns={orderTableColumns}
                        data={filteredData}
                        currentPage={page}
                        totalRecords={filteredData.length}
                        limit={limit}
                        setLimit={setLimit}
                        setPage={setPage}
                        loading={false}
                    />
                </div>
            </div>

            {/* Delete Confirm Modal */}
            {showConfirm && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 animate-fadeIn">
                        <h2 className="text-xl font-semibold text-gray-900 mb-3 text-center">
                            Are you sure?
                        </h2>
                        <p className="text-sm text-gray-600 mb-6 text-center leading-relaxed">
                            Do you really want to delete{" "}
                            <span className="font-medium text-red-600">
                                {selectedRow?.name}
                            </span>
                            ? <br />
                            This action cannot be undone.
                        </p>

                        <div className="flex flex-col sm:flex-row justify-center gap-3">
                            <button
                                onClick={() => setShowConfirm(false)}
                                className="w-full sm:w-auto px-5 py-2.5 text-sm rounded-lg border border-gray-300 bg-white text-gray-700 hover:bg-gray-100 transition"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={() => {
                                    alert(`Deleted ${selectedRow?.name}`);
                                    setShowConfirm(false);
                                }}
                                className="w-full sm:w-auto px-5 py-2.5 text-sm rounded-lg bg-red-600 text-white hover:bg-red-700 shadow-md transition"
                            >
                                Yes, Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FranchiseList
